import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { Consent } from '../model/consent.model';
import { selectConfig } from '../../config/config.selector';
import { AppState } from '../../../app.state';
import { selectUrlParams } from '../../url-params/url-params.selector';
import { UpdateConsent } from '../model/update-consent.model';
import { AbstractRestClient } from '../../../core/services/abstract-rest-client.service';
import { ConfigModel } from '../../config/config.model';
import { UrlParams } from '../../url-params/model/url-params.model';

import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/combineLatest';
import { ApplicationsState } from '../../applications/applications.state';

/**
 * REST Client to access and update Consent.
 *
 * see http://docs.int0csaspsd2selfservice.apiary.io/
 */
@Injectable()
export class ConsentRestClient extends AbstractRestClient {

    ssfUrl: string;

    constructor(private http: HttpClient, private store: Store<AppState>, public storeApp: Store<ApplicationsState>) {
        super(storeApp);

        this.store.select(selectConfig)
            .combineLatest(this.store.select(selectUrlParams))
            .filter(([config, urlParams]: ([ConfigModel, UrlParams])) => !!config  &&  !!urlParams)
            .subscribe(([config, urlParams]: ([ConfigModel, UrlParams])) => {
                this.ssfUrl = config ? config.apiUrl.ssf : null;
                this.init(urlParams.access_token, config.webApiKey, urlParams.lang);
            });
    }

    /**
     * Udělení / odebrání globálního souhlasu uživatele.
     *
     * - Pro dokončení udělení globálního souhlasu je nutné požadavek autorizovat.
     * - Odebrání globálního souhlasu se neautorizuje.
     *
     * V případě odebrání globálního souhlasu jsou rovněž smazány enrollované aplikace daného uživatele,
     * potažmo jsou smazány příslušné enrollment profily v MEP včetně refresh tokenů.
     *
     * https://int0csaspsd2selfservice.docs.apiary.io/#reference/globalni-souhlas
     *                                  /stavudeleniodebrani-globalniho-souhlasu-uzivatele/nastaveni-globalniho-souhlasu
     *
     * @param {consent} consent / stav globálního souhlasu: true - souhlas s PSD2, false - nesouhlas s PSD2
     * @return {Observable<UpdateConsent>}
     */
    public updateConsent(consent: Consent): Observable<UpdateConsent> {
        return this.http.put<UpdateConsent>(this.ssfUrl + `/my/consent`,
            consent,
            { headers: this.headers() });
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/consent/services/consent-rest-client.service.ts